// Derbysoft sends JSON, SOAP providers send XML, both on a single line. Parse
// trouble returns the raw payload: real bytes matter more than pretty output.
export function formatPayload(payload: string): string {
  const trimmed = payload.trim();

  if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
    try {
      return JSON.stringify(JSON.parse(trimmed), null, 2);
    } catch {
      return payload;
    }
  }

  if (trimmed.startsWith('<')) {
    return formatXml(trimmed);
  }

  return payload;
}

function formatXml(xml: string): string {
  // Tag per line, then walk tracking depth. Self-closing tags, the prolog and
  // closing tags are handled so indentation cannot drift on a nested body.
  const lines = xml.replace(/>\s*</g, '>\n<').split('\n');
  const indentUnit = '  ';
  let depth = 0;

  return lines
    .map((rawLine) => {
      const line = rawLine.trim();
      if (!line) {
        return '';
      }

      const isClosing = line.startsWith('</');
      const isSelfContained =
        line.startsWith('<?') ||
        line.startsWith('<!') ||
        line.endsWith('/>') ||
        /^<([\w:.-]+)[^>]*>.*<\/\1>$/.test(line);

      if (isClosing) {
        depth = Math.max(0, depth - 1);
      }

      const indented = `${indentUnit.repeat(depth)}${line}`;

      if (!isClosing && !isSelfContained) {
        depth += 1;
      }

      return indented;
    })
    .filter((line) => line !== '')
    .join('\n');
}

export function formatBytes(byteLength: number): string {
  if (byteLength < 1024) {
    return `${byteLength} B`;
  }
  if (byteLength < 1024 * 1024) {
    return `${(byteLength / 1024).toFixed(1)} KB`;
  }
  return `${(byteLength / (1024 * 1024)).toFixed(1)} MB`;
}
